import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { NewsCategory }     from "Utils/API";



// The initial State
const initialState = {
    loading    : true,
    error      : false,
    edition    : 0,
    canCreate  : false,
    canEdit    : false,
    canFilter  : false,
    canImport  : false,
    canExport  : false,
    list       : [],
    total      : 0,
    elem       : {},
    activities : [],
    statuses   : [],
    sort       : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "NEWS_CATEGORY_LOADING" });
    },

    /**
     * Fetches the News Category List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await NewsCategory.getAll(params);
        data.sort  = params;
        dispatch({ type : "NEWS_CATEGORY_LIST", data });
    },

    /**
     * Fetches a single News Category
     * @param {Function} dispatch
     * @param {Number}   newsCategoryID
     * @returns {Promise}
     */
    async fetchElem(dispatch, newsCategoryID) {
        const data = await NewsCategory.getOne({ newsCategoryID });
        dispatch({ type : "NEWS_CATEGORY_ELEM", data });
        return data;
    },

    /**
     * Fetches the News Category Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await NewsCategory.getEditData();
        dispatch({ type : "NEWS_CATEGORY_EDIT", data });
    },

    /**
     * Edits/Creates a News Category
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return NewsCategory.edit(data);
    },

    /**
     * Deletes the News Category
     * @param {Function} dispatch
     * @param {Number}   newsCategoryID
     * @returns {Promise}
     */
    deleteElem(dispatch, newsCategoryID) {
        return NewsCategory.delete({ newsCategoryID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.isDefaultText = Utils.toYesNo(elem.isDefault);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "NEWS_CATEGORY_LIST", "NEWS_CATEGORY_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "NEWS_CATEGORY_LOADING":
        return {
            ...state,
            loading    : true,
        };

    case "NEWS_CATEGORY_LIST":
        return {
            ...state,
            loading    : false,
            error      : false,
            canCreate  : action.data.canCreate,
            canEdit    : action.data.canEdit,
            canFilter  : action.data.canFilter,
            canImport  : action.data.canImport,
            canExport  : action.data.canExport,
            list       : Utils.parseList(action.data.list, parseElem),
            total      : action.data.total,
            sort       : action.data.sort,
        };

    case "NEWS_CATEGORY_ELEM":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            elem       : parseElem(action.data.elem),
            activities : action.data.activities,
            statuses   : action.data.statuses,
        };

    case "NEWS_CATEGORY_EDIT":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            activities : action.data.activities,
            statuses   : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
